import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { t } from '@avanta/shared/i18n';
import { cn } from '@avanta/shared/utils/cn';
import { Trash } from 'lucide-react';
import { CancelAppointmentDialog } from './CancelAppointmentDialog';
import { type CancelAppointmentProps } from './types';

export const CancelAppointment = ({
  appointment,
  icon,
  buttonLabel = t('CancelAppointment.cta', { ns: LOCIZE_NS.APPOINTMENTS }),
  className,
}: CancelAppointmentProps): React.ReactElement => {
  const { showDialog } = useDialogContext();

  const handleCancelClick = (): void => {
    showDialog({ component: <CancelAppointmentDialog appointment={appointment} /> });
  };

  const isCancelEnabled = !appointment.immovable;

  return (
    <Button
      variant="terciary"
      size="md"
      className={cn('hover:bg-red-100 hover:border-red-300 hover:text-red-700', className)}
      onClick={handleCancelClick}
      icon={icon ?? 'leading'}
      disabled={!isCancelEnabled}
    >
      <Trash className="size-3" />
      {icon !== 'only' && buttonLabel}
    </Button>
  );
};
